import * as Yup from 'yup';
import { isValidInternationalPhoneNumber } from '@rsos/utils/internationalPhoneNumberUtils';
import * as validator from '@rsos/utils/validators';
import {
  DISPLAY_NAME_ERROR,
  CONTACT_NAME_ERROR,
  CONTACT_TITLE_ERROR,
  CONTACT_EMAIL_ERROR,
  CONTACT_PHONE_ERROR,
  NON_EMERGENCY_PHONE_ERROR,
  POPULATION_ERROR,
  FCC_ID_ERROR,
} from './constants';

const baseFormValidation = {
  display_name: Yup.string().test(
    'isValidAgencyName',
    DISPLAY_NAME_ERROR,
    function (value) {
      const { path, createError } = this;
      const result = validator.isValidAgencyName(value)
        ? true
        : createError({ path, message: DISPLAY_NAME_ERROR });
      return result;
    },
  ),
  contact_name: Yup.string()
    .min(2, CONTACT_NAME_ERROR)
    .max(30, CONTACT_NAME_ERROR)
    .required(CONTACT_NAME_ERROR),
  contact_title: Yup.string()
    .min(3, CONTACT_TITLE_ERROR)
    .max(50, CONTACT_TITLE_ERROR)
    .required(CONTACT_TITLE_ERROR),
  contact_phone: Yup.string().test(
    'isValidPhone',
    CONTACT_PHONE_ERROR,
    function (value) {
      const { path, createError } = this;
      const result = isValidInternationalPhoneNumber(value, 'US')
        ? true
        : createError({ path, message: CONTACT_PHONE_ERROR });
      return result;
    },
  ),
  contact_email: Yup.string().test(
    'isValidEmail',
    CONTACT_EMAIL_ERROR,
    function (value) {
      const { path, createError } = this;
      const result = validator.isValidEmail(value)
        ? true
        : createError({ path, message: CONTACT_EMAIL_ERROR });
      return result;
    },
  ),
  non_emergency_phone: Yup.string().test(
    'isValidPhone',
    NON_EMERGENCY_PHONE_ERROR,
    function (value) {
      const { path, createError } = this;
      const result = isValidInternationalPhoneNumber(value, 'US')
        ? true
        : createError({ path, message: NON_EMERGENCY_PHONE_ERROR });
      return result;
    },
  ),
};
export const cspFormValidationSchema = Yup.object().shape(baseFormValidation);

export const rspFormValidationSchema = Yup.object().shape({
  ...baseFormValidation,
  population: Yup.string().test(
    'isValidPopulation',
    POPULATION_ERROR,
    function (value) {
      const { path, createError } = this;
      const result = validator.isValidPopulation(value)
        ? true
        : createError({ path, message: POPULATION_ERROR });
      return result;
    },
  ),
  fcc_id: Yup.string().test('isValidFCCID', FCC_ID_ERROR, function (value) {
    const { path, createError } = this;
    const result = validator.optionalTextField(value, 2, 50)
      ? true
      : createError({ path, message: FCC_ID_ERROR });
    return result;
  }),
});

export const selectBuildOptions = state => ({
  label: state.label,
  value: state.value,
});

export const getInitialStateValue = (list, value) => {
  if (value) {
    const result = list.find(item => item.value === value);
    if (result) {
      return { label: result.label, value: result.value };
    }
    return result || '';
  }
  return '';
};
